<div *ngIf="showTitle" class="p-grid">
    <div class="p-col-12">
        <div class="p-d-flex p-jc-between">
            <h5 class="p-ml-3">{{reportName}}</h5>
            <div>
                <span *ngIf="selectedWindow == ReportsInventoryNames.inventoryValuationSummary
                || selectedWindow == ReportsInventoryNames.inventoryValuationDetail">
                    <p-checkbox [(ngModel)]="showInActive" [binary]="true" inputId="binary" (onChange)="onClickShowInActive()">
                    </p-checkbox>
                    <label for="binary" class="p-mx-2">Show Inactive Items</label>
                </span>
                <span class="p-mr-3">{{reportDate | date: 'short'}}</span>
                <!-- <span class="btnBars" (click)="openSetting()">
                    <i class="pi pi-cog"></i>
                </span> -->
            </div>
        </div>
    </div>
</div>
<p-card *ngIf="chartType == 'simpleBar'">
    <div class="p-d-flex">
        <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
        <div style="flex-grow:1; width:100%">
            <p-chart type="bar" height="200px" [data]="barData" [options]="basicOptions"></p-chart>
        </div>
    </div>
</p-card>
<p-card *ngIf="chartType == 'stackedBar'">
    <div class="p-d-flex">
        <p style="writing-mode: vertical-lr;transform: rotate(180deg);text-align: center;" class="p-mb-0">{{chartLabel}}</p>
        <div style="flex-grow:1; width:100%">
            <p-chart type="bar" height="200px" [data]="stackedBar" [options]="stackedOptions"></p-chart>
        </div>
    </div>
</p-card>
<p-table *ngIf="reportName !== reportNames.averageFieldVisitsByRep && reportType == 'Field'" [columns]="cols" [value]="reportDatas" responsiveLayout="scroll" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns"
            style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                {{col.header}}
            </th>
            <!-- <th>Rep Name</th>
            <th>Geo Matched</th>
            <th>Day Counts</th>
            <th>Average Visits per day</th>
            <th>Average Time Spent per Account</th> -->
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-r>
        <tr>
            <td>{{r.name}}</td>
            <td>{{r.visitCount}}</td>
            <td>{{r.dayCount}}</td>
            <td>{{r.averageVisit}}</td>
            <td>{{r.averageSpend | timeConvert}}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>
<p-table *ngIf="reportName === reportNames.averageFieldVisitsByRep && reportType == 'Field'" [value]="reportDatas" responsiveLayout="scroll" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header">
        <tr>
            <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Rep Name</th>
            <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Geo Matched</th>
            <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Day Counts</th>
            <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Average Visits per day</th>
            <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>Average Time Spent per Account</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-r>
        <tr>
            <td>{{r.repName}}</td>
            <td>{{r.visitCount}}</td>
            <td>{{r.dayCount}}</td>
            <td>{{r.averageVisitsPerDay}}</td>
            <td>{{r.timeSpent | timeConvert}}</td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>
<p-table *ngIf="reportType == 'simpleTBWithAPIPagination'" [value]="reportDatas" [totalRecords]="totalRecords"
    [columns]="cols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [paginator]="true"
    [(first)]="first" (onPage)="getPaginationData($event)"
    styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.header == 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Qty on Hand" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header !== 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span>{{col.header}}</span>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'datetime'">
                        {{ rowData[col.field] | localDate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'date'">
                        {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'timespan'">
                        {{ rowData[col.field] | timeConvert }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'popuplink'">
                        <span class="report-link" (click)="onClickPopupLink(rowData, col)">
                            {{ rowData[col.field] }}
                        </span>
                        <!-- <span class="report-link" (click)="openInvoiceDialog(rowData)">
                            {{ rowData[col.field] }}
                        </span> -->
                    </ng-container>
                    <ng-container *ngSwitchCase="'string'">
                        <span [pTooltip]="rowData[col.field]" tooltipPosition="top">
                            {{ rowData[col.field] | shorten:27 }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ rowData[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>
<p-table *ngIf="reportType == 'simpleTB'" [value]="reportDatas" [columns]="cols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [paginator]="true"
    [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.header == 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Qty on Hand" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header !== 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span>{{col.header}}</span>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'datetime'">
                        {{ rowData[col.field] | localDate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'date'">
                        {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'timespan'">
                        {{ rowData[col.field] | timeConvert }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'popuplink'">
                        <span class="report-link" (click)="onRouteNavigation(rowData, col)">
                            {{ rowData[col.field] }}
                        </span>
                        <!-- <span class="report-link" (click)="openInvoiceDialog(rowData)">
                            {{ rowData[col.field] }}
                        </span> -->
                    </ng-container>
                    <ng-container *ngSwitchCase="'string'">
                        <span [ngClass]="{'report-link': col.field === 'invoicenumber' || col.field === 'salesorderno' || col.field === 'invoiceNo'}" (click)="col.field === 'invoicenumber' || col.field === 'salesorderno' || col.field === 'invoiceNo' ? onRouteNavigation(rowData, col) : null">
                      {{ rowData[col.field] | shorten:27 }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ rowData[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>
<!-- Invoice Pop-Up Dialog -->
<!-- <app-invoice-add-edit [type]="'VIEW'" [displayInvoicingAdd]="displayInvoicingAdd"
    [selectedInvoicing]="selectedInvoiceId"
    (cancel)="onInvoiceDialogCancel($event)">
</app-invoice-add-edit> -->
<p-table *ngIf="reportType == 'clickableTB'" [value]="reportDatas" [columns]="cols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" [(first)]="first" (onRowSelect)="selectedWindow != ReportsInventoryNames.inventoryAging ? showDetails($event) : null"
    [(selection)]="selectedData" selectionMode="single" dataKey="id"
    styleClass="p-datatable-gridlines" [resizableColumns]="true">

    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    {{col.header}}
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'datetime'">
                        {{ rowData[col.field] | localDate }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'date'">
                        {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'timespan'">
                        {{ rowData[col.field] | timeConvert }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'string'">
                        <span [ngClass]="{'report-link': col.field === 'invNo'}" (click)="col.field === 'invNo' ? onRouteNavigation(rowData, col) : null">
                            {{ rowData[col.field] | shorten:27 }}
                        </span>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ rowData[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" *ngIf="reportTotalRow" let-columns>
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'number'">
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ reportTotalRow[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>
<p-table *ngIf="reportType == 'groupTB'" [value]="reportDatas" [columns]="cols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [paginator]="true"
    [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.header == 'ATP'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Available to Pick" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header == 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Qty on Hand" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header !== 'ATP' && col.header !== 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span>{{col.header}}</span>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr class="parentRow">
            <td colspan="10">{{rowData.itemName}}</td>
        </tr>
        <tr *ngFor="let s of rowData.children">
            <td *ngFor="let col of columns">
                {{s[col.field]}}
            </td>
        </tr>
        <!-- <tr class="footerRow" *ngIf="showTotal">
            <ng-container *ngIf="selectedWindow == ReportsInventoryNames.invoiceByRep
            || selectedWindow == ReportsInventoryNames.invoiceByCustomer">
                <td [attr.colspan]="columns.length-2">Total:</td>
                <td>
                    $539.44
                </td>
                <td>
                    $539.44
                </td>
            </ng-container>
            <ng-container *ngIf="selectedWindow == ReportsInventoryNames.profitByRep
            || selectedWindow == ReportsInventoryNames.profitByCustomer">
                <td [attr.colspan]="columns.length-1">Total:</td>
                <td>
                    $5000
                </td>
            </ng-container>
        </tr> -->
    </ng-template>
    <ng-template pTemplate="footer" *ngIf="reportTotalRow" let-columns>
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'number'">
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ reportTotalRow[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>

<!-- **********Simple Table With Summation********* -->
<p-table #reportsGroupTabelHeader *ngIf="reportType == 'groupTSBFDataHeader'" [value]="reportDatas" [columns]="cols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.header == 'ATP'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Available to Pick" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header == 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Qty on Hand" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header !== 'ATP' && col.header !== 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span>{{col.header}}</span>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-index="rowIndex" let-rowData let-columns="columns">
        <tr *ngIf="index>0 ? (reportDatas[index-1][groupTypeColName]!=rowData[groupTypeColName] || index%reportsGroupTabelHeader.rows==0): true" class="parentRow">
            <ng-container *ngFor="let col of columns; let i = index;">
                <td>
                    <ng-container *ngIf="col?.groupField" [ngSwitch]="col?.dataType">
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ rowData[col?.groupField] | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'date'">
                            {{ rowData[col?.groupField] | localDate:'MM/DD/YYYY' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'timespan'">
                            {{ rowData[col?.groupField] | timeConvert }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'number2dp'">
                            {{ rowData[col?.groupField] | customNumberFormat: fractionDigits }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbol'">
                            {{ rowData[col?.groupField] | customNumberFormat: fractionDigits | currencySymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'percentageSymbol'">
                            {{ rowData[col.groupField] | numberWithPercentageSymbol: fractionDigits }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'string'">
                            {{ rowData[col.groupField] | shorten:55 }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col?.groupField] }}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
        </tr>
        <tr>
            <ng-container *ngFor="let col of columns; let i = index;">
                <td>
                    <ng-container [ngSwitch]="col?.dataType">
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ rowData[col.field] | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'date'">
                            {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'timespan'">
                            {{ rowData[col.field] | timeConvert }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'number2dp'">
                            {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbol'">
                            {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'percentageSymbol'">
                            {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'string'">
                            {{ rowData[col.field] | shorten:27 }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>

<p-table *ngIf="reportType == 'simpleTBSData'" [value]="reportDatas" [columns]="cols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.header == 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Qty on Hand" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header !== 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span>{{col.header}}</span>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'datetime'">
                    </ng-container>
                    <ng-container *ngSwitchCase="'timespan'">
                        {{ rowData[col.field] | timeConvert }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'popuplink'">
                        <span class="report-link" (click)="onRouteNavigation(rowData, col)">
                            {{ rowData[col.field] }}
                        </span>
                        <!-- <span class="report-link" (click)="openInvoiceDialog(rowData)">
                            {{ rowData[col.field] }}
                        </span> -->
                    </ng-container>
                    <ng-container *ngSwitchCase="'string'">
                        {{ rowData[col.field] | shorten:27 }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ rowData[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" *ngIf="reportType == 'simpleTBSData' && reportTotalRow" let-columns>
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'number'">
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>
<!-- **********Group Table With Flat Data********* -->
<p-table #reportsGroupTabel *ngIf="reportType == 'groupTBFData'" [value]="reportDatas" [columns]="cols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.header == 'ATP'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Available to Pick" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header == 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Qty on Hand" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header !== 'ATP' && col.header !== 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span>{{col.header}}</span>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-index="rowIndex" let-rowData let-columns="columns">
        <tr *ngIf="index>0 ? (reportDatas[index-1][groupTypeColName]!=rowData[groupTypeColName] || index%reportsGroupTabel.rows==0): true" class="parentRow">
            <td [attr.colspan]="columns.length">{{rowData[groupTypeColName] | shorten:55}}</td>
        </tr>
        <tr>
            <ng-container *ngFor="let col of columns; let i = index;">
                <td>
                    <ng-container [ngSwitch]="col?.dataType">
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ rowData[col.field] | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'date'">
                            {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'timespan'">
                            {{ rowData[col.field] | timeConvert }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'number2dp'">
                            {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbol'">
                            {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'percentageSymbol'">
                            {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'string'">
                            {{ rowData[col.field] | shorten:27 }}
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            {{ rowData[col.field] }}
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" *ngIf="reportTotalRow" let-columns>
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'number'">
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ reportTotalRow[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>
<!-- **********Group Table With Summation********* -->
<p-table #reportsGroupTabelwithSummation *ngIf="reportType == 'groupTSBFData'" [value]="reportDatas" [columns]="cols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [paginator]="true" [(first)]="first" styleClass="p-datatable-gridlines" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <ng-container *ngFor="let col of columns">
                <th *ngIf="col.header == 'ATP'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Available to Pick" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header == 'QOH'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span pTooltip="Qty on Hand" tooltipPosition="top">{{col.header}}</span>
                </th>
                <th *ngIf="col.header == 'a'" style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                </th>
                <th *ngIf="col.header !== 'ATP' && col.header !== 'QOH' && col.header !== 'a'"
                style="border-right: 1px solid var(--primary-color);" pResizableColumn>
                    <span>{{col.header}}</span>
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-index="rowIndex" let-rowData let-columns="columns">
        <tr *ngIf="index>0 ? (reportDatas[index-1][groupTypeColName]!=rowData[groupTypeColName] || index%reportsGroupTabelwithSummation.rows==0): true" class="parentRow">
            <td [attr.colspan]="columns.length">{{rowData[groupTypeColName] | shorten:55}}</td>
        </tr>
        <tr>
            <ng-container *ngFor="let col of columns; let i = index;">
                <td>
                    <ng-container [ngSwitch]="col?.dataType">
                        <ng-container *ngSwitchCase="'datetime'">
                            {{ rowData[col.field] | localDate }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'date'">
                            {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'timespan'">
                            {{ rowData[col.field] | timeConvert }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'number2dp'">
                            {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbol'">
                            {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'currencySymbolIgnoreTotal'">
                            {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'percentageSymbol'">
                            {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                        </ng-container>
                        <ng-container *ngSwitchCase="'string'">
                            <div [hidden]="!col.isShow">
                            </div>
                            <div *ngIf="col.isShow">
                                {{ rowData[col.field] | shorten:27 }}
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <div [hidden]="!col.isShow">
                            </div>
                            <div *ngIf="col.isShow">
                                <span class="report-link" (click)="onRouteNavigation(rowData, col)">
                                {{ rowData[col.field] }}
                                </span>
                            </div>
                        </ng-container>
                    </ng-container>
                </td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" *ngIf="reportType == 'groupTSBFData' && reportTotalRow" let-columns>
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'number'">
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbolIgnoreTotal'">
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbolIgnoreTotal'">
                        {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ reportTotalRow[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="footer" *ngIf="reportType == 'groupTSBFData' && reportTotalRow" let-columns>
        <tr>
            <td *ngFor="let col of columns">
                <ng-container [ngSwitch]="col?.dataType">
                    <ng-container *ngSwitchCase="'number'">
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'number2dp'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbol'">
                        {{ reportTotalRow[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'currencySymbolIgnoreTotal'">
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'percentageSymbol'">
                        {{ reportTotalRow[col.field] | numberWithPercentageSymbol: fractionDigits }}
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        {{ reportTotalRow[col.field] }}
                    </ng-container>
                </ng-container>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="18">{{noData}}</td>
        </tr>
    </ng-template>
</p-table>
<p-dialog header="{{detailsHeader}}" [(visible)]="displayDetails" [modal]="true" [closable]="false" [style]="{width: '60vw'}">
    <div class="card">
        <p-table [value]="reportRowDetails" responsiveLayout="scroll" [columns]="detailsCols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [paginator]="true" [(first)]="first" *ngIf="detailsType == 'simple'">
            <ng-template pTemplate="caption">
                <div class="p-d-flex align-items-center p-jc-between">
                    <div style="flex-grow: 1;">
                        <h5>{{detailsHeaderTitle}}</h5>
                    </div>
                    <div class="p-text-right">
                        <p class="p-mb-0">{{today | localDate}}</p>
                        <div>
                            <p-button (click)="onTableRowDetailsPrintXLSX('print')" class="p-mr-2" icon="pi pi-print"></p-button>
                            <p-button (click)="onTableRowDetailsPrintXLSX('XLSX')" class="p-mr-2" icon="pi pi-download"></p-button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <ng-container *ngFor="let col of columns">
                        <th>
                            {{col.header}}
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                    <td *ngFor="let col of columns">
                        <ng-container [ngSwitch]="col?.dataType">
                            <ng-container *ngSwitchCase="'datetime'">
                                {{ rowData[col.field] | localDate }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'date'">
                                {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'timespan'">
                                {{ rowData[col.field] | timeConvert }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'number2dp'">
                                {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'currencySymbol'">
                                {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'percentageSymbol'">
                                {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                            </ng-container>
                            <ng-container *ngSwitchCase="'string'">
                                {{ rowData[col.field] | shorten:27 }}
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                {{ rowData[col.field] }}
                            </ng-container>
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="18">{{noData}}</td>
                </tr>
            </ng-template>
        </p-table>
        <!-- Details With Group Data -->
        <p-table #reportsDetailsTabel [value]="reportRowDetails" responsiveLayout="scroll" [columns]="detailsCols" [(rows)]="showRows" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [paginator]="true" [(first)]="detailFirst" *ngIf="detailsType == 'group'">
            <ng-template pTemplate="caption">
                <div class="p-d-flex align-items-center p-jc-between">
                    <div style="flex-grow: 1;">
                        <h5>{{detailsHeaderTitle}}</h5>
                    </div>
                    <div class="p-text-right">
                        <p class="p-mb-0">{{today | localDate}}</p>
                        <div>
                            <p-button (click)="onTableRowDetailsPrintXLSX('print')" class="p-mr-2" icon="pi pi-print"></p-button>
                            <p-button (click)="onTableRowDetailsPrintXLSX('XLSX')" class="p-mr-2" icon="pi pi-download"></p-button>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <ng-container *ngFor="let col of columns; let i = index;">
                        <th>
                            {{col.header}}
                        </th>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-index="rowIndex" let-rowData let-columns="columns">
                <tr *ngIf="index>0 ? (reportRowDetails[index-1][detailsGroupTypeColName]!=rowData[detailsGroupTypeColName] || index%reportsDetailsTabel.rows==0): true" class="parentRow">
                    <td [attr.colspan]="columns.length">{{rowData[detailsGroupTypeColName] | shorten:55}}</td>
                </tr>
                <tr>
                    <ng-container *ngFor="let col of columns; let i = index;">
                        <td>
                            <ng-container [ngSwitch]="col?.dataType">
                                <ng-container *ngSwitchCase="'datetime'">
                                    {{ rowData[col.field] | localDate }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'date'">
                                    {{ rowData[col.field] | localDate:'MM/DD/YYYY' }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'timespan'">
                                    {{ rowData[col.field] | timeConvert }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'number2dp'">
                                    {{ rowData[col.field] | customNumberFormat: fractionDigits }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'currencySymbol'">
                                    {{ rowData[col.field] | customNumberFormat: fractionDigits | currencySymbol }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'percentageSymbol'">
                                    {{ rowData[col.field] | numberWithPercentageSymbol: fractionDigits }}
                                </ng-container>
                                <ng-container *ngSwitchCase="'popuplink'">
                                    <span class="report-link" (click)="onRouteNavigation(rowData, col)">
                                        {{ rowData[col.field] }}
                                    </span>
                                </ng-container>
                                <ng-container *ngSwitchCase="'string'">
                                    <span [ngClass]="{'report-link': col.field === 'salesOrderNo'}" (click)="col.field === 'salesOrderNo' ? onRouteNavigation(rowData, col) : null">
                                       {{ rowData[col.field] | shorten:27 }}
                                  </span>
                                </ng-container>
                                <ng-container *ngSwitchDefault>
                                    {{ rowData[col.field] }}
                                </ng-container>
                            </ng-container>
                        </td>
                    </ng-container>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="18">{{noData}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayDetails=false;" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save"></button>
    </p-footer>
</p-dialog>
<app-setting [displaySettings]="displaySettings" (cancelSetting)="cancelSetting()" [cols]="cols"></app-setting>

<!-- Write check view -->
<app-write-check
    *ngIf="displayWriteCheck && overviewRefId"
    [display]="displayWriteCheck"
    [checkId]="overviewRefId"
    [checkDialogType]="'VIEW'"
    (close)="onCloseWriteCheckDialog($event)">
</app-write-check>

<!-- Expense view -->
<app-add-expense
    *ngIf="displayAddEditExpense && overviewRefId"
    [displayAddEditExpense]="displayAddEditExpense"
    [expenseId]="overviewRefId"
    [type]="'VIEW'"
    (close)="onCloseExpenseDialog($event)">
</app-add-expense>

<!-- Credit Card charge view -->
<app-add-credit-card-charge
    *ngIf="displayCreditCardViewDialog && overviewRefId"
    [displayAddEditCreditCard]="displayCreditCardViewDialog"
    [creditCardId]="overviewRefId"
    [type]="'VIEW'"
    (close)="onCloseCreditChargeDialog($event)">
</app-add-credit-card-charge>

<!-- bank register view-->
<app-user-register
    *ngIf="displayBankRegisterViewDialog && overviewRefId"
    [display]="displayBankRegisterViewDialog"
    [dialogType]="'VIEW'"
    [bankRegisterId]="overviewRefId"
    [accountsTransactionMasterID]="transactionMasterId"
    (close)="onCloseBankRegisterViewDialog($event)">
</app-user-register>



<app-inventory-module-overview-dialogs
    *ngIf="displayInventoryOverview"
    [displayOverview]="displayInventoryOverview"
    [overviewRefId]="inventoryOverviewRefId"
    [overviewRefNumber]="inventoryOverviewRefNumber" [confirmVoid]="true"
    [overviewModule]="inventoryOverviewModule" [isView]="isView"
    (onCancel)="closeViewPopup()">
</app-inventory-module-overview-dialogs>
